var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSprintWatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122.493,
    height: 114.904,
    viewBox: "0 0 122.493 114.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2676",
    "data-name": "Ret\\xE2ngulo 2676",
    width: 122.493,
    height: 114.73,
    transform: "translate(-1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#09d785"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#098caf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-sprint-watch",
    transform: "translate(1 0.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5434",
    "data-name": "Grupo 5434",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_2677",
    "data-name": "Ret\\xE2ngulo 2677",
    d: "M2.5,0H22a0,0,0,0,1,0,0V1.667A3.333,3.333,0,0,1,18.667,5H2.5A2.5,2.5,0,0,1,0,2.5v0A2.5,2.5,0,0,1,2.5,0Z",
    transform: "translate(15.746 38.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2951",
    "data-name": "Caminho 2951",
    d: "M0,54.109a2.852,2.852,0,0,1,2.988-1.73c7.855.041,15.711,0,23.566.04a1.443,1.443,0,0,0,1.6-1.078c.966-2.326,2.076-4.593,3.132-6.882a24.7,24.7,0,0,1,4.352-6.5,46.969,46.969,0,0,1,25.44-16.12c.294-.073.577-.19.939-.312,0-1.767.048-3.515-.044-5.256-.017-.323-.545-.747-.928-.9A7.941,7.941,0,0,1,58.911,1.82,8.049,8.049,0,0,1,64.2.008c5.405,0,10.811-.02,16.216,0a7.913,7.913,0,0,1,8.1,6.631c.694,3.843-1.437,7.363-5.367,8.865-.145.055-.288.114-.477.189v5.694c2.725.945,5.478,1.672,8.041,2.824C106.9,31.5,116.33,43.976,119.074,61.509l.3,2.077s.257,2.246.285,4.078a39.67,39.67,0,0,1-1.348,10.227,45.324,45.324,0,0,1-6.189,15c-.872,1.373-2.184,1.773-3.363,1.056-1.2-.733-1.453-2.132-.561-3.556a41.033,41.033,0,0,0,6.218-17.407c1.528-13.8-2.394-25.855-12.288-35.6a42.417,42.417,0,1,0-38.012,71.8A41.553,41.553,0,0,0,94.7,103.7c1.914-1.163,3.236-1.086,4.055.276.78,1.3.253,2.547-1.552,3.672A47.167,47.167,0,0,1,28.78,85.5a1.6,1.6,0,0,0-1.758-1.214c-4.783.055-9.567.027-14.351.021a8.42,8.42,0,0,1-1.51-.089,2.285,2.285,0,0,1-.074-4.456,7.274,7.274,0,0,1,1.506-.112q6.359-.012,12.718,0h1.325c-.484-3.006-.949-5.9-1.444-8.972H24.06c-2.917,0-5.834.008-8.751,0-1.622-.006-2.663-.9-2.7-2.274-.035-1.413,1.04-2.38,2.7-2.386,3.262-.012,6.524,0,9.8,0,.383-2.984.756-5.893,1.149-8.948H24.94c-7.195,0-14.39-.024-21.585.02A3.5,3.5,0,0,1,0,55.509Zm72.286-42.9c2.68,0,5.36.012,8.04,0,2.164-.012,3.641-1.326,3.662-3.217a3.328,3.328,0,0,0-3.6-3.306q-8.1-.035-16.2,0a3.27,3.27,0,0,0-3.52,3.359c.041,1.884,1.446,3.145,3.577,3.16,2.68.019,5.36,0,8.04,0m5.6,4.738H66.78v4.665H77.89Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2953",
    "data-name": "Caminho 2953",
    d: "M152.451,100.9a36.2,36.2,0,1,1-36.242,36.043A36.191,36.191,0,0,1,152.451,100.9m-.012,4.668a31.533,31.533,0,1,0,31.48,31.674,31.523,31.523,0,0,0-31.48-31.674",
    transform: "translate(-80.047 -69.505)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2954",
    "data-name": "Caminho 2954",
    d: "M326.93,313.842a2.267,2.267,0,0,1,2.355-2.221,2.3,2.3,0,1,1-.158,4.6,2.276,2.276,0,0,1-2.2-2.381",
    transform: "translate(-225.195 -214.651)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2955",
    "data-name": "Caminho 2955",
    d: "M205.189,182.283c-4.265-.045-8.487-4.173-6.87-8.891a1.286,1.286,0,0,0-.384-1.6c-1.437-1.365-2.827-2.782-4.216-4.2-1.156-1.178-1.243-2.5-.269-3.506s2.409-.921,3.6.249c1.414,1.391,2.822,2.788,4.2,4.214a1.182,1.182,0,0,0,1.5.368,6.528,6.528,0,0,1,4.789,0,1.2,1.2,0,0,0,1.5-.363q5.091-5.138,10.222-10.237c.247-.247.484-.508.754-.73a2.324,2.324,0,0,1,3.176.079,2.291,2.291,0,0,1,.106,3.168c-.715.818-1.518,1.56-2.287,2.33-2.858,2.862-5.7,5.738-8.592,8.567a1.467,1.467,0,0,0-.4,1.8c1.535,4.657-2.389,8.7-6.825,8.75m0-9.684a3.5,3.5,0,0,0-3.015,3.175,3.191,3.191,0,0,0,3.015,2.805,3.141,3.141,0,0,0,2.831-2.805,3.329,3.329,0,0,0-2.831-3.175",
    transform: "translate(-132.791 -108.148)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2956",
    "data-name": "Caminho 2956",
    d: "M229.7,132.932c0,.425.029.853-.006,1.276a2.289,2.289,0,0,1-2.062,2.153,2.214,2.214,0,0,1-2.476-1.795,11.628,11.628,0,0,1-.023-3.113,2.2,2.2,0,0,1,2.42-1.864,2.262,2.262,0,0,1,2.143,2.184c.029.385,0,.773,0,1.16",
    transform: "translate(-155.012 -89.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2957",
    "data-name": "Caminho 2957",
    d: "M301.69,209.829c.387,0,.774-.018,1.16,0a2.334,2.334,0,0,1,2.3,2.171,2.3,2.3,0,0,1-2.023,2.431,12.421,12.421,0,0,1-2.777,0,2.233,2.233,0,0,1-1.983-2.441,2.258,2.258,0,0,1,2.279-2.161c.347-.019.7,0,1.044,0",
    transform: "translate(-205.519 -144.53)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2958",
    "data-name": "Caminho 2958",
    d: "M224.957,286.387c0-.389-.021-.779,0-1.167a2.319,2.319,0,0,1,2.235-2.254,2.269,2.269,0,0,1,2.361,1.99,12.738,12.738,0,0,1,.006,2.793,2.3,2.3,0,0,1-2.332,2.033,2.342,2.342,0,0,1-2.268-2.228c-.028-.387,0-.778-.006-1.167",
    transform: "translate(-154.949 -194.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2959",
    "data-name": "Caminho 2959",
    d: "M148.218,209.7a12.012,12.012,0,0,1,1.4.009A2.2,2.2,0,0,1,151.6,211.8a2.136,2.136,0,0,1-1.748,2.394,12.314,12.314,0,0,1-3.014.056,2.25,2.25,0,0,1-2.023-2.319,2.3,2.3,0,0,1,2.236-2.245c.386-.032.777,0,1.165,0v.021",
    transform: "translate(-99.752 -144.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_33",
    "data-name": "Elipse 33",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(-0.254 79.826)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_2",
    "data-name": "Subtra\\xE7\\xE3o 2",
    d: "M21006,22061h-17a8,8,0,0,1,0-16h17a8,8,0,0,1,0,16Zm-17-11a3,3,0,0,0,0,6h17a3,3,0,1,0,0-6Z",
    transform: "translate(-20925.254 -22045.174)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtra\\xE7\\xE3o_3",
    "data-name": "Subtra\\xE7\\xE3o 3",
    d: "M20988.5,22060a7.5,7.5,0,1,1,7.5-7.5A7.51,7.51,0,0,1,20988.5,22060Zm0-10a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,20988.5,22050Z",
    transform: "translate(-20916.254 -21985.174)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSprintWatch);
export default __webpack_public_path__ + "static/media/icon-sprint-watch.03c5ec8dd0b00fe101b3edb940006cb8.svg";
export { ForwardRef as ReactComponent };